
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M16 18c2.198 0 4-1.802 4-4s-1.802-4-4-4-4 1.802-4 4 1.802 4 4 4zm0-10c3.303 0 6 2.697 6 6a5.997 5.997 0 0 1-2.336 4.745c3.141 1.361 5.336 4.45 5.336 8.05v.088a1 1 0 1 1-2 0v-.088C23 23.045 19.898 20 16.06 20h-.12C12.101 20 9 23.046 9 26.795V27a1 1 0 0 1-2 0v-.205c0-3.6 2.195-6.689 5.336-8.051A5.994 5.994 0 0 1 10 14c0-3.303 2.697-6 6-6z"}}),_c('path',{attrs:{"d":"M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3zm0-2c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1z"}})])])
          )
        }
      }
    